export default "__VITE_ASSET__ac84x1oO__"